import { ComponentProps } from 'react';

import type TextInput from 'components/molecules/form/TextInput';

const FORM_NAMES = {
  CREATE_INSTANCE_WITH_VARIABLES: 'CREATE_INSTANCE_WITH_VARIABLES',
  FORM_FACTORY: 'FORM_FACTORY',
  ADVANCED_SEARCH_CONFIGURE: 'ADVANCED_SEARCH_CONFIGURE',
  WRAPPER: 'WRAPPER',
  SELECT_CONNECTION: 'SELECT_CONNECTION',
  GRID_TEMPLATES: 'GRID_TEMPLATES',
  SAVE_GRID_TEMPLATE: 'SAVE_GRID_TEMPLATE',
  SCANNING_INDEXING: 'SCANNING_INDEXING',
  DEFINITION_SEARCH: 'DEFINITION_SEARCH',
  EXECUTION_SEARCH: 'EXECUTION_SEARCH',
  SECURITY_GROUP_CONFIG: 'SECURITY_GROUP_CONFIG',
  GRID_SEARCH: 'GRID_SEARCH',
  DELETE_ENTITY_MULTISTEP: 'DELETE_ENTITY_MULTISTEP',
  EXTERNAL_TIMEOUT: 'EXTERNAL_TIMEOUT',
  FINISH_INSTANCE: 'FINISH_INSTANCE',
  RE_INDEX_FORM: 'RE_INDEX_FORM',
  SEND_EMAIL_WITH_FILE_OR_FORM: 'SEND_EMAIL_WITH_FILE_OR_FORM',
  SCANNING_DOCUMENT_CONTAINER: 'SCANNING_DOCUMENT_CONTAINER',
};

enum ApiObligationType {
  readOnly = 'read_only',
  fillRequired = 'fill_required',
  fillOptional = 'fill_optional',
}
/**
 * Common validation for password creation fields.
 *
 * if this is causing a type error in your TextInput because your TextInput has types, cast it to any when you spread it
 *
 * {...(PASSWORD_FIELD_REQUIREMENTS as any)}
 */
export const PASSWORD_FIELD_REQUIREMENTS: Partial<
  ComponentProps<typeof TextInput>
> = {
  minLength: 16,
  maxLength: 65,
};

export { FORM_NAMES, ApiObligationType };
